module.exports = __webpack_public_path__ + "media/images/components/base/container/gradient-hero-banner-mobile@2x-0b3156330376d95c59571494c435d7f4.jpg";